"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.urlResolve = void 0;
/**
 * Returns resolved URL
 * @param base
 * @param path
 * @returns resolved url
 */
function urlResolve(base, path) {
    try {
        return new URL(path, base).toString();
    }
    catch (e) {
        var updatedBase = base;
        // Add protocol prefix if missing
        if (!base.startsWith('http')) {
            updatedBase = 'https:' + base;
        }
        var basePattern = new RegExp('/$');
        var pathPattern = new RegExp('^/');
        if (basePattern.test(updatedBase) || pathPattern.test(path)) {
            return updatedBase + path;
        }
        return updatedBase + '/' + path;
    }
}
exports.urlResolve = urlResolve;
